export function getRootVar(cssVar: string, defaultValue?: string) {
  let style = getComputedStyle(document.body);
  let value = style.getPropertyValue(cssVar)
  
  if (defaultValue) {
    return value ? value : defaultValue
  } else {
    return value;
  }
}